<template>
    <div id="liaowang">
        <slider :platInfo = platInfo></slider>
    </div>
</template>

<script>
    import slider from '../../components/slider.vue'
    export default {
        name: "liaowang",
        components:{slider},
        data() {
            return {
                swiper: null,
                platInfo:liaowangInfo,
            }
        },
        methods: {},
        mounted() {

        }
    }
</script>

<style lang="css" scoped>
    #liaowang{
        width: 100%;
        display: flex;
        flex-direction: row;
        height: 100%;
        overflow: auto;
        background: linear-gradient(to right,#C1F2F9,#fff,#C1F2F9);;
    }
</style>



// WEBPACK FOOTER //
// src/views/liaowang/liaowang.vue